var React = require('react');

function StationeryCrease (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,30.537C0,19.8,0,9.455,0,0c10.105,10.084,20.61,20.566,30.606,30.537C21.268,30.537,10.646,30.537,0,30.537z"}));
}

StationeryCrease.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"30.606px","height":"30.537px","viewBox":"0 0 30.606 30.537","enableBackground":"new 0 0 30.606 30.537","xmlSpace":"preserve"};

module.exports = StationeryCrease;

StationeryCrease.default = StationeryCrease;
